import { Observable, of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { ofType, Epic } from "redux-observable";

import { Action } from "@ctra/utils";
import { SavedChartsResponse } from "./typings";

import { makeAzureApiURL } from "../../utils/ajax";
import types from "./types";
import actions from "./actions";

/**
 * Fetch saved charts
 * @param action$
 * @param state$
 * @param Request
 */
const fetchSavedCharts: Epic = (action$, state$, { Request }) =>
  action$.pipe(
    ofType(types.FETCH_SAVED_CHARTS.pending),
    mergeMap(() =>
      Request.GET(makeAzureApiURL("accounts", "/self/saved-charts")()).pipe(
        map<{ response: SavedChartsResponse }, Action>(({ response }) =>
          actions.fetchSavedCharts.fulfill(response)
        ),
        catchError<unknown, Observable<Action>>((error) => of(actions.fetchSavedCharts.reject(error)))
      )
    )
  );

/**
 * Update tabs (add/remove/reorder)
 * @param action$
 * @param state$
 * @param Request
 */
const updateTabs: Epic = (action$, state$, { Request }) =>
  action$.pipe(
    ofType(types.UPDATE_TABS.pending),
    mergeMap<ReturnType<typeof actions.updateTabs.start>, Observable<Promise<unknown>>>(
      ({ payload: { pageKey, savedCharts } }) =>
        Request.PUT(makeAzureApiURL("accounts", `/self/saved-charts?pageKey=${pageKey}`)(), {
          body: savedCharts
        }).pipe(
          map<{ response: null }, Action>(() => actions.updateTabs.fulfill(pageKey, savedCharts)),
          catchError<unknown, Observable<Action>>((error) => of(actions.updateTabs.reject(error)))
        )
    )
  );

/**
 * Save chart to group/tab
 * @param action$
 * @param state$
 * @param Request
 */
const updateCharts: Epic = (action$, state$, { Request }) =>
  action$.pipe(
    ofType(types.UPDATE_CHARTS.pending),
    mergeMap<ReturnType<typeof actions.updateCharts.start>, Observable<Promise<unknown>>>(
      ({ payload: { pageKey, savedCharts } }) =>
        Request.PUT(makeAzureApiURL("accounts", `/self/saved-charts?pageKey=${pageKey}`)(), {
          body: savedCharts
        }).pipe(
          map<{ response: null }, Action>(() => actions.updateCharts.fulfill(pageKey, savedCharts)),
          catchError<unknown, Observable<Action>>((error) => of(actions.updateCharts.reject(error)))
        )
    )
  );

export default {
  updateCharts,
  updateTabs,
  fetchSavedCharts
};
